import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useSelector, useDispatch } from 'react-redux';

import $ from 'jquery';

import ProductCategoryCreate from './Create';
import { DeleteButton, SubmitButton } from '../../components/Base';
import { API_URL, DATATABLES_DEFAULT_CONFIG, APP_URL } from '../../constants/env';
import { STATUS_STRING } from '../../constants/data';
import { deleteProductCategory } from '../../actions/productCategory';

export default function ProductCategory() {
  const productCategoryFormRef = useRef();

  const { result: authenticatedUser } = useSelector((state) => state.authenticatedUser);
  const { refresh } = useSelector((state) => state.productCategory);
  const dispatch = useDispatch();

  useEffect(() => {
    initializeDataTables();
  }, [refresh]);

  const initializeDataTables = () => {
    $('#productCategoryDataTable').DataTable().destroy();
    $('#productCategoryDataTable').DataTable({
      ...DATATABLES_DEFAULT_CONFIG,
      ajax: {
        url: `${API_URL}/product-category?source=datatables`,
        dataSrc: 'data',
        beforeSend: (xhr) =>
          xhr.setRequestHeader('Authorization', `Bearer ${authenticatedUser.token}`),
      },
      columns: [
        { data: 'order' },
        { data: 'name' },
        {
          data: 'image',
          searchable: false,
          sortable: false,
          createdCell: (cell, cellData) =>
            ReactDOM.render(<img src={`${APP_URL}/${cellData}`} alt="" className="h-16" />, cell),
        },
        {
          data: 'parent_category',
          searchable: false,
          sortable: false,
          render: (data) => (data ? data.name : '-'),
        },
        { data: 'type' },
        {
          data: 'is_featured',
          render: (data) => (data === 1 ? '✓' : ''),
        },
        {
          data: 'status',
          render: (data) => STATUS_STRING[data],
        },
        {
          data: 'id',
          searchable: false,
          sortable: false,
          createdCell: (cell, cellData, rowData) =>
            ReactDOM.render(
              <div>
                <SubmitButton
                  color="blue"
                  textClass="text-white text-xs"
                  paddingClass="px-3 py-2 mr-1"
                  text="Edit"
                  onClick={() => onPressEdit(rowData)}
                />
                <DeleteButton
                  color="red"
                  textClass="text-white text-xs"
                  paddingClass="px-3 py-2"
                  onClick={() => onPressDelete(rowData)}
                />
              </div>,
              cell,
            ),
        },
      ],
      columnDefs: [
        { width: '20px', targets: [0] },
        { className: 'dt-center', targets: [0, 5, 6] },
      ],
    });
  };

  const onPressCreate = () => productCategoryFormRef.current.showForm();
  const onPressEdit = (data) => productCategoryFormRef.current.showFormWithInitialData(data);
  const onPressDelete = (data) => dispatch(deleteProductCategory(data.id));

  return (
    <>
      <div className="relative flex flex-col min-w-0 w-full h-full bg-white mb-8 shadow-lg rounded-xl">
        {/* Header */}
        <div className="flex flex-wrap items-center py-3 border-b">
          <div className="px-4 flex-1">
            <h3 className="font-semibold text-gray-800 pl-2">Kategori Produk</h3>
          </div>
          <div className="px-4">
            <SubmitButton
              textClass="text-white text-xs"
              text="Tambah Kategori Produk"
              onClick={onPressCreate}
            />
            <ProductCategoryCreate ref={productCategoryFormRef} />
          </div>
        </div>

        {/* Table Content */}
        <div className="block w-full overflow-x-auto p-6">
          {/* Projects table */}
          <table
            id="productCategoryDataTable"
            className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th className="px-6 bg-gray-100 text-gray-600 align-middle border border-solid border-gray-200 border-l-0 border-r-0 text-xs uppercase font-semibold text-left">
                  Order
                </th>
                <th className="px-6 bg-gray-100 text-gray-600 align-middle border border-solid border-gray-200 border-l-0 border-r-0 text-xs uppercase font-semibold text-left">
                  Name
                </th>
                <th className="px-6 bg-gray-100 text-gray-600 align-middle border border-solid border-gray-200 border-l-0 border-r-0 text-xs uppercase font-semibold text-left">
                  Image
                </th>
                <th className="px-6 bg-gray-100 text-gray-600 align-middle border border-solid border-gray-200 border-l-0 border-r-0 text-xs uppercase font-semibold text-left">
                  Parent Category
                </th>
                <th className="px-6 bg-gray-100 text-gray-600 align-middle border border-solid border-gray-200 border-l-0 border-r-0 text-xs uppercase font-semibold text-left">
                  Type
                </th>
                <th className="px-6 bg-gray-100 text-gray-600 align-middle border border-solid border-gray-200 border-l-0 border-r-0 text-xs uppercase font-semibold text-left">
                  Featured
                </th>
                <th className="px-6 bg-gray-100 text-gray-600 align-middle border border-solid border-gray-200 border-l-0 border-r-0 text-xs uppercase font-semibold text-left">
                  Status
                </th>
                <th className="px-6 bg-gray-100 text-gray-600 align-middle border border-solid border-gray-200 border-l-0 border-r-0 text-xs uppercase font-semibold text-left w-40"></th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </div>
      </div>
    </>
  );
}
